import React from "react";
import { CheckIcon } from "lucide-react";
import { understandings } from "../data/steps";
import { SectionCTA } from "./SectionCTA";
export function ProblemSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-248" data-mp="30gxu3xcr9fmr">
      <div className="mx-auto max-w-3xl" data-id="element-249" data-mp="30isjbnv27twn">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-250" data-mp="2vqr907hgcd99">
          From a complex case that feels scattered…
          <span className="mt-2 block text-brand" data-id="element-251" data-mp="39g2tt701zf0i">to a case strategy you can see on one page.</span>
        </h2>

        <p className="mt-8 text-center text-lg text-muted" data-id="element-252" data-mp="35in73ijjg3dh">I've created this system around a problem I see again and again:</p>

        <ul className="mt-6 space-y-3" data-id="element-253" data-mp="3eh8ohad9xcco">
          {understandings.map(line => <li key={line} className="flex items-start gap-3 rounded-2xl bg-canvas px-4 py-3.5 text-[17px] font-medium text-ink" data-id="element-254" data-mp="1p214al8qymec">
              <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand text-white" data-id="element-255" data-mp="1k3r94an0vlsq">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-256" data-mp="jeepei9tj9fw" />
              </span>
              {line}
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-navy-900 px-6 py-8 text-center text-white md:px-10" data-id="element-257" data-mp="sdthfm5mvs2i">
          <p className="text-lg text-white/80" data-id="element-258" data-mp="x4i84z9hol0l">But when all of those pieces have to come together for one patient…</p>
          <p className="mt-3 font-serif text-3xl font-extrabold italic text-brand-cyan md:text-4xl" data-id="element-259" data-mp="1244jf35rbr6r">where do you actually start?</p>
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-ink" data-id="element-260" data-mp="170uypo9qmir4">That is the problem the Ortho Case Command Center™ was designed to solve.</p>

        <SectionCTA label="I want to see my case on one page" data-id="element-261" data-mp="1g3w57q2imbvb" />
      </div>
    </section>;
}